import './Header.css';
import { actions } from '../../context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
    faCheck,
    faTimes,
    faBellSlash,
    faRandom,
    faPlus,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const formatStat = (stat) => {
    if (stat === undefined || stat === null) return `--`;
    if (stat === 0) return `0`;
    return stat;
};

const DashboardStats = () => {
    const dispatch = useDispatch();

    const onClick = (filterName) => {
        dispatch(actions.practice.setActiveTabPractices(filterName));
    };
    
    // TODO: make this feature its own redux slice
    const selectorFunction = (state) => {
        const { newPracticesCount, stalePracticesCount, mutedPracticesCount, conversionPracticesCount, activePracticesCount } = state.practice.dashboardInfo;
        return { newPracticesCount, stalePracticesCount, mutedPracticesCount, conversionPracticesCount, activePracticesCount };
    }
    const dashboardStats = useSelector(selectorFunction, shallowEqual);

    return (
        <div className="d-none d-sm-block">
            <div
                onClick={() => onClick('new')}
                className="dashboard-stat d-inline-block text-primary"
                title="New practices">
                <FontAwesomeIcon className="pop-hover" icon={faPlus} />
                {formatStat(dashboardStats.newPracticesCount)}
            </div>
            <div
                onClick={() => onClick('stale')}
                className="dashboard-stat d-inline-block text-danger"
                title="Stale practices">
                <FontAwesomeIcon className="pop-hover" icon={faTimes} />
                {formatStat(dashboardStats.stalePracticesCount)}
            </div>
            <div
                onClick={() => onClick('muted')}
                className="dashboard-stat d-inline-block text-warning"
                title="Muted practices">
                <FontAwesomeIcon className="pop-hover" icon={faBellSlash} />
                {formatStat(dashboardStats.mutedPracticesCount)}
            </div>
            <div
                onClick={() => onClick('manual_conversions')}
                className="dashboard-stat d-inline-block text-bitwerx"
                title="Conversion practices">
                <FontAwesomeIcon className="pop-hover" icon={faRandom} />
                {formatStat(dashboardStats.conversionPracticesCount)}
            </div>
            <div
                onClick={() => onClick('live')}
                className="dashboard-stat d-inline-block text-success"
                title="Live practices">
                <FontAwesomeIcon className="pop-hover" icon={faCheck} />
                {formatStat(dashboardStats.activePracticesCount)}
            </div>
        </div>
    );
};

export default DashboardStats;
